import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment/moment';
import Select from 'react-select';
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HashLoader } from "react-spinners";

const Transection = ({ customerList, leasingAgent, remarksList, loader, unitData, transData, setTransData, setPeriodFrom, setPeriodTo, setLeaseTerm, periodFrom, leaseTerm, periodTo }) => {
    const [FilterTab, setFilterTab] = useState(true);
    const [tentantTab, setTanantTab] = useState(false);
    const [tentantJoint, setTanantJoint] = useState(false);

    const apiService = new LeaseApiService();

    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const calculateDaysDifference = (from, to) => {
        const fromDate = new Date(from);
        const toDate = new Date(to);
        const diffTime = toDate - fromDate;
        let totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return (totalDays + 1)
    };
    useEffect(() => {
        const today = new Date();
        const nextYear = new Date(today);
        nextYear.setFullYear(today.getFullYear() + 1);
        nextYear.setDate(nextYear.getDate() - 1);
        const formattedToday = today.toISOString().split("T")[0];
        const formattedNextYear = nextYear.toISOString().split("T")[0];

        setPeriodFrom(formattedToday);
        setPeriodTo(formattedNextYear);
        setTransData({
            transectionDate: formattedToday,
            periodFrom: formattedToday,
            periodTo: formattedNextYear,
            leaseTerm: calculateDaysDifference(formattedToday, formattedNextYear),
        })
        setLeaseTerm(calculateDaysDifference(formattedToday, formattedNextYear));
    }, []);
    const handlePeriodToChange = ({ name, value }) => {
        const newToDate = value;
        if (new Date(newToDate) <= new Date(periodFrom)) {
            toast.warning("Period To date cannot be earlier than Period From date.");
            return;
        }
        const formattedDate = formatDate(newToDate);
        setPeriodTo(formattedDate);
        setLeaseTerm(calculateDaysDifference(periodFrom, formattedDate));
    };
    const handlePeriodFromChange = ({ name, value }) => {
        const newFromDate = value;
        const newToDate = new Date(newFromDate);
        newToDate.setFullYear(newToDate.getFullYear() + 1);

        const formattedFrom = formatDate(newFromDate);
        const formattedTo = formatDate(newToDate);

        setPeriodFrom(formattedFrom);
        setPeriodTo(formattedTo);
        setLeaseTerm(calculateDaysDifference(formattedFrom, formattedTo));
    };
    const handleInputChange = ({ name, value }) => {
        if (name === 'transectionDate') {
            if (new Date(value) > new Date(periodFrom)) {
                toast.warning(`Transaction Date should be earlier than Period From`);
                return;
            }
            setTransData({ ...transData, [name]: formatDate(value) });
        }
        setTransData({ ...transData, [name]: value });
    };
    const handlefieldChange = (e) => {
        const { name, value } = e.target;
        if (name === "noInstallment") {
            if (value < 1) {
                toast.warning('No of Installment must be grater then or equal to "1');
                return;
            }
        }
        setTransData({ ...transData, [e.target.name]: e.target.value });
    };
    const handleCustomer = async (selectedOption) => {
        if (transData?.JointCustomerName?.label === selectedOption?.label) {
            toast?.warning(`Primary Customer Should be Different from Joint `)
            return;
        }
        else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                CustomerName: selectedOption,
                CustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleCustomerAccount = async (selectedOption) => {
        if (transData?.JointCustomerAccount?.label === selectedOption?.label) {
            toast?.warning(`Primary Customer Should be Different from Joint `)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                CustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
                CustomerName: { label: selectedOption?.value, value: selectedOption?.label },
            });
        }
    }
    const handleJointCustomer = async (selectedOption) => {

        if (transData?.CustomerName?.label === selectedOption?.label) {
            toast?.warning(`Joint Customer Should be Different from Primary`)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.value);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                JointCustomerName: selectedOption,
                JointCustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
            });
        }
    }
    const handleJointCustomerAccount = async (selectedOption) => {
        if (transData?.CustomerAccount?.label === selectedOption?.label) {
            toast?.warning(`Joint Customer Should be Different from Primary`)
            return;
        } else {
            const params = new URLSearchParams();
            params.append('Action', 'GetCustomerDetailsByTenantNo');
            params.append('TenantNo', selectedOption?.label);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            setTransData({
                ...transData,
                JointCustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
                JointCustomerName: { label: selectedOption?.value, value: selectedOption?.label },
            });
        }
    }
    const handleAgentChange = (selectedOption) => {
        setTransData({
            ...transData,
            leaseAgent: selectedOption,
        });
    }
    const handleBrokerChange = (selectedOption) => {
        setTransData({
            ...transData,
            Broker: selectedOption,
        });
    }
    const handleRemarksChange = (selectedOption) => {
        setTransData({
            ...transData,
            remarks: selectedOption,
            remarks2: selectedOption?.value
        });
    }
    return (
        <div className=''>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Transaction Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        {loader === true ?
                            <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                            <div className="form-group grid-contain ">
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Transaction Date</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={transData?.transectionDate}
                                        onChange={(date) => handleInputChange({ name: 'transectionDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="periodFrom" className="form-label pt-1 start">Period From</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodFrom}
                                        onChange={(date) => handlePeriodFromChange({ name: 'periodFrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="periodTo" className="form-label pt-1 start">Period To</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodTo}
                                        onChange={(date) => handlePeriodToChange({ name: 'periodTo', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="leaseTerm" className="form-label pt-1 start">Lease Term</label>
                                    <input
                                        type="text"
                                        className="p-2 form-control w-75"
                                        name="leaseTerm"
                                        value={leaseTerm}
                                        readOnly
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">No. Of Installments</label>
                                    <input type="number" className="p-2 form-control w-75" name="noInstallment" min={1}
                                        value={transData?.noInstallment} onChange={handlefieldChange} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Select Remarks</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.remarks}
                                        options={remarksList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                                    <input type="text" className="p-2 form-control w-75" name="remarks2"
                                        onChange={handlefieldChange}
                                        value={transData?.remarks2} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Arabic Remarks</label>
                                    <input type="text" className="p-2 form-control w-75" name="arabicRemarks"
                                        onChange={handlefieldChange}
                                        value={transData?.arabicRemarks} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setTanantTab(!tentantTab)}>
                    <div className='h6 pt-1'>Tenant Primary Details</div>
                </div>
                <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                        {loader === true ?
                            <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                            <div className="form-group grid-contain ">
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.CustomerName}
                                        options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handleCustomer(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.CustomerAccount}
                                        options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={(selectedOption) => handleCustomerAccount(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                    <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.CustomerAccount?.value?.ContactNo} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                    <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.CustomerAccount?.value?.Email} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                    <input type="text" className="p-2 form-control w-75" name="installments" value={transData?.CustomerAccount?.value?.IDNo} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.Nationality} readOnly />

                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.VATRegNo} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leasing Agent</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.leaseAgent}
                                        options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={(selectedOption) => handleAgentChange(selectedOption)}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="cost-center-section my-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setTanantJoint(!tentantJoint)}>
                    <div className='h6 pt-1'>Tenant Joint Details</div>
                </div>
                <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                        {loader === true ?
                            <div className="center p-5"><HashLoader color="#6e5199" /></div> :
                            <div className="form-group grid-contain ">
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Name</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.JointCustomerName}
                                        options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                        onChange={(selectedOption) => handleJointCustomer(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Acc/ Code</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.JointCustomerAccount}
                                        options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={(selectedOption) => handleJointCustomerAccount(selectedOption)}
                                    />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No.</label>
                                    <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.JointCustomerAccount?.value?.ContactNo} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                                    <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.JointCustomerAccount?.value?.Email} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport / ID</label>
                                    <input type="text" className="p-2 form-control w-75" name="installments" readOnly value={transData?.JointCustomerAccount?.value?.IDNo} />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.Nationality} readOnly />

                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Vat Reg No</label>
                                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.VATRegNo} readOnly />
                                </div>
                                <div className="d-flex">
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Broker</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-75 p-0"
                                        value={transData.Broker}
                                        options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                        onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Transection;
